<template>
  <div>
    <h2>Filter:</h2>
    <button class="btn back-btn" type="button" @click="resetFilters()">
      <span>Reset</span>
      <font-awesome-icon
        :icon="['fas', 'undo']"
        class="icon alt"
      />
    </button>
    <form-component>
      <form novalidate="novalidate" @submit.prevent>
        <!-- 
        <counselor-lookup-input 
          :value="value.counselor_id" 
          @input="emitFilters({ counselor_id: $event })" /> -->

        <label class="replacement-label">RELATED TOPICS</label>
        <div class="form-row hide-label">
          <div class="col-12">
            <vue-tags-input
              :value="value.specialty"
              placeholder=""
              :add-only-from-autocomplete="true"
              :autocomplete-items="filteredSpecialties"
              :autocomplete-min-length="0"
              :tags="value.specialty_ids"
              label="Related Topic"
              @tags-changed="emitFilters({specialty_ids:$event})"
            />
          </div>
        </div>
        
        <input-datepicker
          id="start_time_after"
          :value="value.start_time_after"
          @input="emitFilters({start_time_after:$event})"
          name="start_time_after"
          label="Start After"
          type="text"
        />

        <input-datepicker
          id="start_time_before"
          :value="value.start_time_before"
          @input="emitFilters({start_time_before:$event})"
          name="start_time_before"
          label="Start Before"
          type="text"
        />
      </form>
    </form-component>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputDatepicker from '@/components/inputs/InputDatepicker.vue';
import CounselorLookupInput from '@/bettermynd-admin/components/CounselorLookupInput.vue'
import VueTagsInput from '@johmun/vue-tags-input';
import UserClient from '@/api/UserClient';
import AdminClient from '@/api/AdminClient';

export default {
  name: "WorkshopsListFilters",
  components: {
    FormComponent,
    VueTagsInput,
    InputDatepicker,
    CounselorLookupInput,
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({
        counselor_id: null,
        start_time_after: null,
        start_time_before: null,
        specialty: '',
        specialty_ids: [],
      })
    }
  },
  data(){
    return { 
      all_specialties: [],
      userClient: new UserClient(this.$http),
      adminClient: new AdminClient(this.$http),
    }
  },
  async mounted() {
    const all_specialties = await this.userClient.getSpecialtiesList('', 500);
    this.all_specialties = all_specialties.results || [];
  },
  computed: {
    filteredSpecialties() {
      return this.all_specialties.filter(i => {
        return i.name.toLowerCase().indexOf(this.value.specialty.toLowerCase()) !== -1;
      }).map(r => ({ id: r.id, text: r.text, }));
    },
  },
  methods:{
    emitFilters(change) {
      this.$emit("input", {
        ...this.value,
        ...change,
      })
    },
    resetFilters() {
      this.emitFilters({
        counselor_id: null,
        start_time_after: null,
        start_time_before: null,
        specialty: '',
        specialty_ids: [],
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>